import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import Card from "./Card";
import AppCarousel from "./global/AppCarousel";
import { useBreakpoints } from "../hooks/useBreakpoints";

const Collection = ({
  collectionType,
  items,
  heading,
  users,
  isInfinite,
  speed,
}) => {
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const userDetails = useSelector((state) => state.userDetails);
  const { user } = userDetails;

  const cardType = collectionType.slice(0, collectionType.length - 1);
  const { lg } = useBreakpoints();

  return (
    <>
      <div className="slider-content">
        <div style={{ padding: "0", marginLeft: "16px", overflow: "hidden" }}>
          {heading && (
            <div className="collection-heading">
              <h4>{heading}</h4>
            </div>
          )}
          {items?.length ? (
            <AppCarousel
              withArrows={lg}
              className="lg:px-20"
              isInfinite={isInfinite}
              speed={speed}
            >
              {items.map((item, index) =>
                user ? (
                  <Card
                    key={index}
                    content={item}
                    cardType={cardType}
                    user={user}
                  />
                ) : users ? (
                  <Card
                    key={index}
                    content={item}
                    cardType={cardType}
                    user={users.find((user) => user._id === item.partner)}
                  />
                ) : (
                  <Card key={index} content={item} cardType={cardType} />
                )
              )}
            </AppCarousel>
          ) : (
            <p>
              {cardType === "experience"
                ? "No experiences available"
                : cardType === "partner"
                ? "No partners available"
                : "Not available"}
            </p>
          )}
          {userInfo &&
            userInfo.type === "partner" &&
            user &&
            user._id === userInfo._id && (
              <p style={{ margin: "60px 0" }}>
                <Link to="/add-experience" className="btn">
                  add new experience
                </Link>
              </p>
            )}
        </div>
      </div>
    </>
  );
};

export default Collection;
